
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { SocialIncentiveButtonsBase } from '../SocialIncentiveButtonsBase.class';
import { IncentiveStep } from 'interfaces';
import { Ref } from 'vue';

export default class DirectSigninButton extends SocialIncentiveButtonsBase {
	protected readonly buttonName = 'DirectButton';

	constructor(protected store: IIncentiveV2Store, private readonly isRegister: Ref<boolean>) {
		super(store, true);
	}

	public goToDirectRegistation(): void {
		this.isRegister.value = true;
		this.store.mutations.setStep(IncentiveStep.LOGIN);
	}
}
